import { cx } from "@emotion/css";

interface CustomBadgeProps {
	count: number;
	maxCount: number;
	className?: string;
	children?: (label: string | number) => React.ReactNode;
}

export const getBadgeLabel = (
	count: number,
	maxCount: number,
): string | number => (count > maxCount ? `+${maxCount}` : count);

export const CustomBadge = ({
	count,
	maxCount,
	className,
}: CustomBadgeProps) => {
	const label = getBadgeLabel(count, maxCount);

	return <div className={cx(className, "custom-badge")}>{label}</div>;
};
